<script>
import RedemptionChannelDetail from "@/view/components/lpm/wizard-steps/RedemptionChannelDetail.vue";
import NoLocation from "@/view/components/lpm/wizard-steps/NoLocation.vue";
export default {
  name: "redemotion-channel",
  components: {
    RedemptionChannelDetail,
    NoLocation
  },
  data() {
    return {
      locations: []
    };
  },
  computed: {
    getLocations() {
      return this.$store.getters["getLpmLocations"];
    }
  },
  watch: {
    getLocations(newVal) {
      this.locations = newVal;
    }
  }
};
</script>

<template>
  <div>
    <no-location v-if="locations.length === 0"></no-location>
    <v-card
      v-if="locations.length > 0"
      class="mx-auto mb-5 p-5"
      max-width="700"
    >
      <v-simple-table>
        <thead>
          <tr>
            <th class="text-left">
              Location
            </th>
            <th class="text-left">
              Redemption Channel
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-for="item in locations">
            <redemption-channel-detail
              :item="item"
              :key="item.id"
            ></redemption-channel-detail>
          </template>
        </tbody>
      </v-simple-table>
    </v-card>
  </div>
</template>
